window.addEventListener("load", (event) => {
    // Slider Accueil
    $('#marques_slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 1000,
        infinite: true,
        adaptiveHeight: false,
        arrows: true,
        responsive: [
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    });

    // Slider Pages
    $('#slider_head').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 1000,
        infinite: true,
        adaptiveHeight: false,
        arrows: false,
        asNavFor: '#slider_head_title'
    });

    // Slider Pages
    $('#slider_head_title').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        fade: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 1000,
        infinite: true,
        adaptiveHeight: false,
        arrows: false,
        asNavFor: '#slider_head'
    });

    //  Grab Cursor when grabbing a Slide
    $(".slick-slide").on("mousedown touchstart", function() {
        $(this).addClass('grabbing');
    });

    $(".slick-slide").on("mouseup touchend", function() {
        $(this).removeClass('grabbing');
    });
});